import React, { useEffect, useState, Fragment } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory, Route, Switch } from 'react-router-dom';
import { SRow, SCol, SContainer } from '@avalara/skylab-sdk/react';
import ProgressBar from '@avalara/bat-apps-shared/client/components/ProgressBar';
import { setActiveFlow } from '../../store/system';
import { setHeaderProductName } from '../../lib/aui-header';
import { checkIsAuthenticated } from '../../lib/helpers';
import { getLoginFromUrl, getMarketingDataFromUrl } from '../../lib/side-effects';
import { fetchAccountForReturns } from '../../lib/side-effects/accounts';
import { initializeReturnsProgressBar, stepNames } from '../../lib/side-effects/progress-bar';
import { selectState } from '../../selectors';
import { currentStepLabelSelector } from '../../selectors/progress-bar';
import Company from '../offer/forms/company';
import GetStarted from '../offer/forms/get-started';
import { useAbandonedCart } from '../shared/hooks';
import LoginPrompt from '../shared/login-prompt';
import OrderSummary from './order-summary';
import Accordion from './accordion';
import BuyButtonAndDisclaimer from './buy-button-and-disclaimer';
import CybersourcePaymentPage from '../cybersource-payment';
const Returns = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const { account: { isLoggedIn }, system: { activeFlow }, } = useSelector(selectState);
    const currentStepLabel = useSelector(currentStepLabelSelector);
    useEffect(() => {
        dispatch(getMarketingDataFromUrl());
        dispatch(initializeReturnsProgressBar());
        setHeaderProductName('Managed Returns');
    }, []);
    useState(getLoginFromUrl());
    useAbandonedCart();
    const onPaymentStep = currentStepLabel === stepNames.paymentMethod;
    useEffect(() => {
        dispatch(setActiveFlow('returns'));
        if (isLoggedIn && !onPaymentStep) {
            history.push({ pathname: '/returns/payment', search: window.location.search });
        }
        if (!isLoggedIn && !checkIsAuthenticated())
            dispatch(fetchAccountForReturns('returns'));
    }, [isLoggedIn]);
    if (!isLoggedIn && !/net-new/.test(activeFlow || ''))
        return React.createElement(LoginPrompt, null);
    return (React.createElement(SContainer, { role: 'main' },
        React.createElement(SRow, null,
            React.createElement(SCol, { span: '8', className: 'pad-top-sm' }, !isLoggedIn && React.createElement(ProgressBar, null))),
        React.createElement(SRow, null,
            React.createElement(SCol, { span: '8' },
                React.createElement(Fragment, null,
                    React.createElement(Switch, null,
                        React.createElement(Route, { path: '/returns/company' },
                            React.createElement(Company, { flow: 'returns', shouldFetchRegionsAndCountries: false })),
                        React.createElement(Route, { path: '/returns/payment' },
                            React.createElement(CybersourcePaymentPage, { paymentView: 'offer' })),
                        React.createElement(Route, { path: '/' },
                            React.createElement(GetStarted, { flow: 'returns' }))),
                    React.createElement(Accordion, null))),
            React.createElement(SCol, { span: '4' },
                React.createElement(OrderSummary, null),
                onPaymentStep && React.createElement(BuyButtonAndDisclaimer, null)))));
};
export default Returns;
